module.exports = __webpack_public_path__ + "img/icon_kehu_08.402ab641.png";